import React, { useEffect, useRef, useState } from 'react';
import debounce from 'lodash.debounce';

import LoadsService from '../providers/Loads/Loads.service';
import { BaseQueryParams } from '../providers/Global.model';
import { LoadLocation } from '../redux/api/load/load.model';

const useTwLocation = (
  getLatest?: boolean
): {
  locations: LoadLocation[];
  setLocations: React.Dispatch<React.SetStateAction<LoadLocation[]>>;
  fetchLocations: (name?: string) => void;
} => {
  const [locations, setLocations] = useState<LoadLocation[]>([]);

  const debounceSearch = useRef(
    // getLatest: get last 10 locations added
    debounce(({ name, getLatest }: { name?: string; getLatest?: boolean }) => {
      const query: BaseQueryParams = {};

      if (name) query.search = name;

      if (getLatest) {
        query.limit = 10;
        query.order_by = 'desc';
        query.sort_by = 'created_at';
      }

      LoadsService.getLocations(query).then((newLocations) => setLocations(newLocations));
    }, 300)
  ).current;

  useEffect(() => {
    return (): void => debounceSearch.cancel();
  }, [debounceSearch]);

  const fetchLocations = (name?: string): void => {
    if (!name && !getLatest) {
      debounceSearch.cancel();
      setLocations([]);
      return;
    }

    if (!name && getLatest) {
      debounceSearch({ getLatest });
      return;
    }

    debounceSearch({ name });
  };

  return { locations, setLocations, fetchLocations };
};

export default useTwLocation;
